import React, { useState } from 'react'
import toast from 'react-hot-toast';
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import CustomMenuItem from '../../../../components/Menu/CustomMenuItem';
import impersonate from "../../../../styles/svg/Impersonate.svg";
import { impersonateUser } from '../../../../services/apiUser';
import FormDialog from '../../../../components/Dialog/FormDialog';
import { Typography } from '@mui/material';
import { persistImpersonationSession } from '../../../../utils/storageUtils';

function ImpersonateUser({ params, onMenuClose = () => {} }) {
  const [open, setOpen] = useState(false)
  function handleLogout() {
    impersonateUser({ username: params.row.email })
      .then((res) => {
        const data = res?.data.data.responseData[0]
        const newWindow = window.open(
          "/my-task?tab=mine",
          "_blank"
        );

        persistImpersonationSession(
          {
            token: data?.token?.access_token,
            refresh_token: data?.token?.refresh_token,
            userId: data?.user_data.user_id,
            role: data?.user_data.role,
          },
          newWindow.sessionStorage
        );
        setOpen(false)
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });

  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <>
      {open && (
        <FormDialog
          open={open}
          handleClose={handleClose}
          //   loading={isLogoutLoading}
          handleSubmit={handleLogout}
          buttonTxt="Impersonate"
          //   title="Confirmation: Log Out"
          cancelBtn={true}
          alignActions={"center"}
          fullWidth={true}
          isHeader={false}
        >
          <div className="impersonate-confirmation">
            <ErrorOutlineOutlinedIcon className="confirmation-icon" />
            <Typography className="impersonate-confirmation-title">
              Impersonate User?
            </Typography>
            <Typography className="impersonate-confirmation-description">
              You are about to impersonate <span className='impersonate-confirmation-description-name'>[{params.row.first_name} {params.row.last_name}]</span>.
              Do you want to continue?
            </Typography>
          </div>
        </FormDialog>
      )}
      <CustomMenuItem
        onClick={() => {
          setOpen(true);
          onMenuClose();
        }}
      >
        <img src={impersonate} className="mr-3" />
        Impersonate
      </CustomMenuItem>
    </>
  );
}

export default ImpersonateUser
